module.exports = ".table tr {\n  border-top: 1px solid #e1e1e1; }\n\n.table .buttons_holder {\n  text-align: right; }\n  .table .buttons_holder .btn-align {\n    margin-bottom: 0;\n    margin-top: -7px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/template-list/template-list.scss
// module id = ./web/modern/components/settings/common/template-list/template-list.scss
// module chunks = 0